import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=242498a4&"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242498a4')) {
      api.createRecord('242498a4', component.options)
    } else {
      api.reload('242498a4', component.options)
    }
    module.hot.accept("./PrimaryNavItem.vue?vue&type=template&id=242498a4&", function () {
      api.rerender('242498a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/PrimaryNavItem.vue"
export default component.exports